module.exports = __webpack_public_path__ + "static/media/codiepie.e9f11ca2.svg";